/**
 * Image URL Helper
 * Constructs full image URLs by appending IMAGE_BASE_URL to relative paths
 */

const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || process.env.REACT_APP_API_URL || "http://192.168.0.24:5000";

/**
 * Append IMAGE_BASE_URL to relative path to construct full URL
 * @param imageUrl - Relative path (e.g., /uploads/templates/image.jpg) or full URL
 * @returns Full URL (e.g., http://192.168.0.24:5000/uploads/templates/image.jpg)
 */
export function getImageUrl(imageUrl: string | undefined | null): string {
  if (!imageUrl) {
    return "";
  }

  // If it's already a full URL (starts with http:// or https://), return as is
  if (imageUrl.startsWith("http://") || imageUrl.startsWith("https://")) {
    return imageUrl;
  }

  // Ensure relative path starts with /
  const relativePath = imageUrl.startsWith("/") ? imageUrl : `/${imageUrl}`;

  // Remove trailing slash from base URL
  const baseUrl = IMAGE_BASE_URL.replace(/\/$/, "");

  // Append IMAGE_BASE_URL
  return `${baseUrl}${relativePath}`;
}

/**
 * Get image URL with fallback placeholder
 * @param imageUrl - Relative path or full URL
 * @param placeholder - Placeholder URL if imageUrl is empty
 * @returns Full URL or placeholder
 */
export function getImageUrlWithFallback(imageUrl: string | undefined | null, placeholder: string = "https://via.placeholder.com/400x300?text=No+Image"): string {
  if (!imageUrl) {
    return placeholder;
  }

  return getImageUrl(imageUrl);
}
